import { Company } from '../dto/Interfaces/ICompany';
import jsonParse from '../typesafe/jsonParse';

interface DateFilter {
  startDate: Date;
  endDate: Date;
  label?: string;
}
export const setActiveCompany = (newCompany: Company) => {
  localStorage.setItem('activeCompany', JSON.stringify(newCompany));
};

export const getActiveCompany = (): Company | null => {
  const activeCompanyJson = localStorage.getItem('activeCompany');
  const activeCompany = jsonParse<Company>(activeCompanyJson);
  return activeCompany;
};

export const setAccessToken = (token: string) => {
  localStorage.setItem('accessToken', JSON.stringify(token));
};

export const getAccessToken = (): string | null => {
  const tokenJson = localStorage.getItem('accessToken');
  const token = jsonParse<string>(tokenJson);
  return token;
};

export const setDateRangeFilter = ({ startDate, endDate, label }: DateFilter) => {
  localStorage.setItem('dateRangeFilter', JSON.stringify({ startDate: startDate, endDate: endDate, label: label }));
};

export const getDateRangeFilter = (): DateFilter | null => {
  const json = localStorage.getItem('dateRangeFilter');
  const dateRangeFilter = jsonParse<DateFilter>(json);
  if (dateRangeFilter) {
    return { startDate: new Date(dateRangeFilter.startDate), endDate: new Date(dateRangeFilter.endDate), label: dateRangeFilter.label };
  }
  return null;
};
